var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "altasCrm" },
    [
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: {
            "padding-right": "0px",
            "padding-left": "10px",
            "padding-top": "15px"
          }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Nombre Tramo...",
                  clearable: "",
                  "prepend-icon": "description",
                  "append-icon": "search"
                },
                model: {
                  value: _vm.model_filtro_tramo,
                  callback: function($$v) {
                    _vm.model_filtro_tramo = $$v
                  },
                  expression: "model_filtro_tramo"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "flex xs6 sm3 md2" },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: "Tipo de Tramo",
                  "item-text": "configvalor",
                  "item-value": "configid",
                  items: _vm.filtro_tipo,
                  clearable: "",
                  "prepend-icon": "account_circle"
                },
                model: {
                  value: _vm.model_filtro_tipo,
                  callback: function($$v) {
                    _vm.model_filtro_tipo = $$v
                  },
                  expression: "model_filtro_tipo"
                }
              })
            ],
            1
          ),
          _c("div", { staticClass: "flex xs6 sm3 md1" }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.applyfilters } },
                  [
                    _c("v-icon", { attrs: { color: "#27488e" } }, [
                      _vm._v("search")
                    ]),
                    _vm._v("Filtrar")
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "flex xs6 sm3 md1" }, [
            _c(
              "div",
              { staticClass: "text-sm-center botones-filtros" },
              [
                _c(
                  "v-btn",
                  { on: { click: _vm.cleanfilters } },
                  [
                    _c("v-icon", { attrs: { color: "#27488e" } }, [
                      _vm._v("clear")
                    ]),
                    _vm._v("Limpiar")
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _c("div", {
        staticClass: "layout row wrap",
        staticStyle: { "padding-right": "0px", "padding-left": "10px" }
      }),
      _c(
        "div",
        {
          staticClass: "layout row wrap",
          staticStyle: { "padding-right": "0px", "padding-left": "10px" }
        },
        [
          _c(
            "div",
            { staticClass: "flex xs12 sm6 md6", attrs: { align: "lef" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm12: "", md12: "" } },
                [
                  _c("v-text-field", {
                    staticStyle: { "padding-left": "15px" },
                    attrs: { label: "Buscar..." },
                    on: { input: _vm.searchDataActividad },
                    model: {
                      value: _vm.filtrobusquedaTramos,
                      callback: function($$v) {
                        _vm.filtrobusquedaTramos = $$v
                      },
                      expression: "filtrobusquedaTramos"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "flex xs12 sm6 md6 layout row wrap",
              attrs: { align: "right" }
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    sm12: "",
                    md12: "",
                    layout: "",
                    "justify-end": "",
                    "align-center": "",
                    "mt-3": "",
                    "mb-4": ""
                  }
                },
                [
                  _c(
                    "v-btn",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: true,
                          expression: "true"
                        }
                      ],
                      staticClass: "btn-crear v-btn theme--light",
                      on: { click: _vm.handlerbuttonmodal }
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass:
                            "v-icon v-icon--left material-icons theme--dark",
                          staticStyle: { color: "black" },
                          attrs: { "aria-hidden": "true" }
                        },
                        [_vm._v("add_circle_outline")]
                      ),
                      _c("span", [_vm._v("Crear")])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-card",
        [
          _c(
            "div",
            { staticClass: "gridcard rounded-card grilla_altas_crm" },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "funcionalidad-id": _vm.funcionalidad
                }
              })
            ],
            1
          ),
          _vm.tramosModalState
            ? _c("ModalCrearTramo", {
                attrs: {
                  show: _vm.tramosModalState,
                  Tramo_Seleccionada: _vm.tramos_Seleccionada,
                  isEdit: _vm.isEdit
                },
                on: { cerrar: _vm.handleCierreModalAsignacion }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }